export default __webpack_public_path__ + "static/SourceSansPro-SemiBoldItalic-c30987e28fc21daba1ae919b0da22941.ttf";